import { Box, Typography } from "@material-ui/core";
import styled from "styled-components";

export const ButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
  margin-bottom: 8px;
`;

export const NoLocationText = styled(Typography)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
